
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Berechnungen basieren auf den Daten aus der `}<Link url='https://www.ecoinvent.org/database/database.html' mdxType="Link">{`Ecoinvent-v3.5-Datenbank`}</Link>{`. Ein neu angepflanzter Buchenwald kann über 100 Jahre betrachtet pro Hektare etwa `}<nobr>{`630 Tonnen CO`}<sub>{`2`}</sub></nobr>{` aufnehmen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;